import React from "react";
import { Icon } from "signoxe/components/widgets";
import "./styles.scss";
const CampaignAddTIle = ({
  onClickAdd,
  canAdd,
  onNameChange,
  onCancel,
  onAdd,
}) => {
  return (
    <div className="CampaignAddTile">
      {!canAdd && (
        <button
          onClick={() => onClickAdd()}
          className="CampaignAddTile__button"
        >
          <Icon title="Delete" name="plus" size="1.25rem" color="black" />
          <span class="CampaignAddTile__buttonTitle">
            Add New <br /> Campaign
          </span>
        </button>
      )}

      {canAdd && (
        <div className="CampaignAddTile__add">
          <div className="CampaignAddTile__icon">
            <span className="CampaignAddTile__iconBg">
              <Icon title="folder" name="folder" size="1.25rem" color="white" />
            </span>
          </div>
          <div className="CampaignAddTile__content">
            <input
              type="text"
              name="campaignName"
              onChange={(e) => onNameChange(e)}
              placeholder="Campaign Name"
            />
          </div>
          <div className="CampaignAddTile__actions">
            <button onClick={(e) => onAdd(e)}>Add</button>
            <Icon
              title="cancel"
              name="times"
              size="1.25rem"
              color="black"
              onClick={() => onCancel()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignAddTIle;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/CampaignAddTile/index.js